

import {  
  loadElevationDataInProgress,
  loadElevationDataSuccess,
  loadElevationDataFailure,
  elevationOperationCompleted,
  loadChangeRoleDataSuccess,
  loadChangePermissionDataSuccess,
  loadUserPermissionDataSuccess
} from "../state/elevation/actions";

import configData from "../config.json";
import { errorSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';
import swal from 'sweetalert';
const serverBasePath=configData.SERVER_API_URL;
let abortController = null;

export const loadRoleChangeRequestList = (searchText,page=0,pageSize=10) => async (dispatch) => {
    const token = oktaAuth.getAccessToken(); 
    if (!token) throw new Error('No access token');
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
      dispatch(loadElevationDataInProgress());
      const response = await fetch(serverBasePath+"/elevation/roleElevationRequest?searchText="+searchText+"&page="+page+"&pageSize="+pageSize,
      {
        signal,
        method: "GET",    
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        }
      });
      const result = await response.json();
      if(response.status !==  200){
          oopsSweetAlert(result);
          return;
      } 
      dispatch(loadChangeRoleDataSuccess(result));
    } catch (e) {
      dispatch(loadElevationDataFailure());
      if (e.name === "AbortError") {
        //errorSweetAlert({message:'The operation was aborted.'}); 
      }
    }
};




export const loadPermissionsChangeRequestList = (searchText,page=0,pageSize=10) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const signal = abortController.signal;
  try {
    dispatch(loadElevationDataInProgress());
    const response = await fetch(serverBasePath+"/elevation/permissionElevationRequest?searchText="+searchText+"&page="+page+"&pageSize="+pageSize,
    {
      signal,
      method: "GET",    
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadChangePermissionDataSuccess(result));
  } catch (e) {
    dispatch(loadElevationDataFailure());
    if (e.name === "AbortError") {
      //errorSweetAlert({message:'The operation was aborted.'}); 
    }
  }
};



export const loadUserInformation = () => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadElevationDataInProgress());
    const response = await fetch(serverBasePath+"/user/getUserInformation",
    {
      method: "GET",    
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadElevationDataSuccess(result));
  } catch (e) {
    dispatch(loadElevationDataFailure());
    errorSweetAlert(e); 
  }
};


export const updateUserPermissions = (userId,permissions) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  let data = {
    'userId' : userId,
    'permissions' : permissions
  }
  dispatch(loadElevationDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/user/updatepermissions", 
      {
          method: "PUT",  
          headers: {
            Authorization: 'Bearer ' + token,       
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(data)
      });
      dispatch(elevationOperationCompleted());
      const result = await response.json();
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      swal("Success", result.message, "success");
  } catch (e) {
      dispatch(loadElevationDataFailure());
      errorSweetAlert(e);
  }
};

export const roleUpdateRequest = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadElevationDataInProgress());
    const body = JSON.stringify(data);
    const response = await fetch(serverBasePath+"/elevation/roleUpdateRequest", 
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      method: "post",
      body,
    });
    dispatch(elevationOperationCompleted());
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    swal({
      title: "Success",
      text: result.message,
      icon: "success",
      closeOnClickOutside:false,
      closeOnEsc: false,
      allowOutsideClick: false,
   })
} catch (e) {
  dispatch(loadElevationDataFailure(e));
  errorSweetAlert(e); 
}
};


export const rejectRoleChangeRequest = (requestId,page) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken(); 
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadElevationDataInProgress());
            const response = await fetch(serverBasePath+"/elevetion/rejectRoleChangeRequest/"+requestId,
            {
              method: "PUT",
              headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
              }
            });
            dispatch(elevationOperationCompleted()); 
            const result = await response.json();
            if(response.status !==  200){
                oopsSweetAlert(result);
                return;
            }
            swal({
                title: "Success",
                text: result.message,
                icon: "success",
                closeOnClickOutside:false,
                closeOnEsc: false,
                allowOutsideClick: false,
            })
            .then(marked => {
                if (marked) {
                    dispatch(loadRoleChangeRequestList('',page))
                }
            });
        } catch (e) {   
          dispatch(loadElevationDataFailure());
          errorSweetAlert(e); 
        }
    };
};


export const approveRoleChangeRequest = (data,page) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken(); 
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadElevationDataInProgress());
            const response = await fetch(serverBasePath+"/elevetion/approveRoleChangeRequest",
            {
              method: "PUT",
              headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data)
            });
            dispatch(elevationOperationCompleted()); 
            const result = await response.json();
            if(response.status !==  200){
                oopsSweetAlert(result);
                return;
            }
            swal({
                title: "Success",
                text: result.message,
                icon: "success",
                closeOnClickOutside:false,
                closeOnEsc: false,
                allowOutsideClick: false,
            })
            .then(marked => {
                if (marked) {
                    dispatch(loadRoleChangeRequestList('',page))
                }
            });
        } catch (e) {   
            dispatch(loadElevationDataFailure());
            errorSweetAlert(e); 
        }
    };
};


export const permissionUpdateRequest = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    const body = JSON.stringify(data);
    dispatch(loadElevationDataInProgress());
    const response = await fetch(serverBasePath+"/elevation/permissionUpdateRequest", 
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      method: "post",
      body,
    });
    dispatch(elevationOperationCompleted());
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    swal({
      title: "Success",
      text: result.message,
      icon: "success",
      closeOnClickOutside:false,
      closeOnEsc: false,
      allowOutsideClick: false,
   })
} catch (e) {
  dispatch(loadElevationDataFailure(e));
  errorSweetAlert(e); 
}
};


export const rejectPermissionChangeRequest = (requestId,page) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken(); 
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadElevationDataInProgress());
          const response = await fetch(serverBasePath+"/elevetion/rejectPermissionChangeRequest/"+requestId,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(elevationOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                  dispatch(loadPermissionsChangeRequestList('',page))
              }
          });
      } catch (e) {   
          dispatch(loadElevationDataFailure());
          errorSweetAlert(e); 
      }
  };
};


export const approvePermissionChangeRequest = (data,page) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken(); 
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadElevationDataInProgress());
          const response = await fetch(serverBasePath+"/elevetion/approvePermissionChangeRequest",
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
          });
          dispatch(elevationOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                  dispatch(loadPermissionsChangeRequestList('',page))
              }
          });
      } catch (e) {   
          dispatch(loadElevationDataFailure());
          errorSweetAlert(e); 
      }
  };
};


export const loadUserCurrentPermissions = (rowId) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadElevationDataInProgress());
    const response = await fetch(serverBasePath+"/elevation/getUserCurrentPermissions/"+rowId,
    {
      method: "GET",    
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadUserPermissionDataSuccess(result));
  } catch (e) {
    dispatch(loadElevationDataFailure());
    errorSweetAlert(e); 
  }
};


export const loadUserRequestedPermissions = (rowId) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadElevationDataInProgress());
    const response = await fetch(serverBasePath+"/elevation/getUserRequestedPermissions/"+rowId,
    {
      method: "GET",    
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadUserPermissionDataSuccess(result));
  } catch (e) {
    dispatch(loadElevationDataFailure());
    errorSweetAlert(e); 
  }
};
